import PraguePlugin from './plugin/PraguePlugin';
import createLazyPlugin, { LazyPlugin } from 'owa-editor-lazy-plugin/lib/utils/createLazyPlugin';
import { LazyModule, LazyImport } from 'owa-bundling';
import { PluginEventType } from 'roosterjs-editor-types';

export { default as isValidPragueURL } from './utils/isValidPragueURL';

const lazyModule = new LazyModule(() => import(/* webpackChunkName: "Prague" */ './lazyIndex'));

export type LazyPraguePlugin = LazyPlugin<PraguePlugin>;

export let LazyPraguePluginClass = createLazyPlugin(
    lazyModule,
    m => m.PraguePlugin,
    'Prague',
    event => event.eventType == PluginEventType.EditorReady
);

export let lazyPreWarmBohemiaTokens = new LazyImport(lazyModule, m => m.preWarmBohemiaTokens);

export let lazyMountBohemiaComponent = new LazyImport(lazyModule, m => m.mountBohemiaComponent);

export let lazyParseBohemiaURL = new LazyImport(lazyModule, m => m.parseBohemiaURL);

// Types
export { LazyPlugin };
